export default __webpack_public_path__ + "static/media/order-arrived-bot.f79e99a0.gif";